import { Action } from '@ngrx/store';
export const CHECKOUT_FORM_UPDATE = '[Checkout Form] Checkout Form update';
export const CHECKOUT_FORM_PLACE_ORDER = '[Checkout Form] Checkout Form Place Order';
export const CHECKOUT_FORM_DATEPICKER_UPDATE = '[Checkout Form] Datepicker Form update';
export class UpdateCheckoutForm implements Action {
  readonly type = CHECKOUT_FORM_UPDATE;
  constructor(public payload: { formsObjectValue: any }) {}
}

export class UpdateDatepickerForm implements Action {
  readonly type = CHECKOUT_FORM_DATEPICKER_UPDATE;
  constructor(public payload: { min: string; max: string }) {}
}

export class PlaceOrderUsingCheckoutForm implements Action {
  readonly type = CHECKOUT_FORM_PLACE_ORDER;
  constructor() {}
}

export type CheckoutFormsActions = UpdateCheckoutForm | PlaceOrderUsingCheckoutForm;
